var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function InTheNews(el) {
  var $el = $(el),
      $posts = $el.find('#media-stories'),
      $paginate = $el.find('#load-more');

  $paginate.on('click', 'a', function(e) {
    e.preventDefault();
    var $link = $(this).attr('href');
    $paginate.html('<span class="loader">Loading more...</span>');
    $.get($link, function(data) {
      var $post = $('#media-stories li', data);
      $posts.append($post);
    });
    $paginate.load($link + ' #load-more a');
  });
}

module.exports = InTheNews;
